import { getHeaders } from '@utility/helperFunction';

export const GET_STATION_EMP_REQUESTED = 'empAssign/GET_STATION_EMP_REQUESTED';
export const GET_STATION_EMP_SUCCESS = 'empAssign/GET_STATION_EMP_SUCCESS';
export const GET_STATION_EMP_FAILURE = 'empAssign/GET_STATION_EMP_FAILURE';

const initialState = {
    loading: false,
    loaded: false,
    error: false,
    stationEmpData: null,
};

export default (state = initialState, action) => {
  switch (action.type) {

        case GET_STATION_EMP_REQUESTED: {
            return { ...state, loading: true, loaded: false, error: false };
        }
        case GET_STATION_EMP_SUCCESS: {
            return { ...state, loading: false, loaded: true, error: false, stationEmpData: action.result };
        }
        case GET_STATION_EMP_FAILURE: {
            return { ...state, loading: false, loaded: false, error: true };
        }
        default:
            return state;
    }
};


export const getStationEmployees = (data) => {
    const headers = getHeaders();
    return {
        types: [GET_STATION_EMP_REQUESTED, GET_STATION_EMP_SUCCESS, GET_STATION_EMP_FAILURE],
        promise: client => client.post('getStationEmployees', { data, headers })
    }
}

export const removeTableAssignment = (data) => {
    const headers = getHeaders();
    return {
        types: [GET_STATION_EMP_REQUESTED, GET_STATION_EMP_SUCCESS, GET_STATION_EMP_FAILURE],
        promise: client => client.post('removeTableAssignment', { data, headers })
    }
}

export const assignTable = (data) => {
    const headers = getHeaders();
    return {
        types: [GET_STATION_EMP_REQUESTED, GET_STATION_EMP_SUCCESS, GET_STATION_EMP_FAILURE],
        promise: client => client.post(`assignTable`, { data, headers })
    }
}

export const assignEmployee = (data) => {
    const headers = getHeaders();
    return {
        types: [GET_STATION_EMP_REQUESTED, GET_STATION_EMP_SUCCESS, GET_STATION_EMP_FAILURE],
        promise: client => client.post(`assignEmployee`, { data, headers })
    }
}

export const removeEmployeeAssignment = (data) => {
    const headers = getHeaders();
    return {
        types: [GET_STATION_EMP_REQUESTED, GET_STATION_EMP_SUCCESS, GET_STATION_EMP_FAILURE],
        promise: client => client.post('removeEmployeeAssignment', { data, headers })
    }
}
